import { ILeadRepository } from '../../infrastructure/repositories'

export class CheckPhoneUseCase {
 constructor(private leadRepository: ILeadRepository) {}

 async execute(phone: string, currentLeadPhones?: string[]): Promise<{
 exists: boolean
 warning: string | null
 leadId?: string
 }> {
 if (!phone || phone.replace(/\D/g, '').length < 10) {
 return { exists: false, warning: null }
 }

 const cleanPhone = phone.replace(/\D/g, '')
 const currentLeadHasPhone = currentLeadPhones?.some(
 p => p.replace(/\D/g, '') === cleanPhone
 )

 if (currentLeadHasPhone) {
 return { exists: false, warning: null }
 }

 try {
 const result = await this.leadRepository.checkPhoneExists(phone)
 if (result.exists && result.lead) {
 return {
 exists: true,
 warning: `⚠️ Este telefone já está cadastrado para o cliente: ${result.lead.name || 'Desconhecido'}`,
 leadId: result.lead.id,
 }
 }
 return { exists: false, warning: null }
 } catch (error) {
 console.error('Erro ao verificar telefone:', error)
 return { exists: false, warning: null }
 }
 }
}

